import "./styles-v2.css";
import Phaser from "phaser";
import { BootScene } from "./game/scenes/BootScene";
import { FarmSceneV2 } from "./game/scenes/FarmSceneV2";
import { GameStore } from "./game/state/GameStore";
import { GameUI } from "./game/ui/GameUI";
import { gameEvents } from "./game/events";
import { BUILD_INFO } from "./buildInfo";

declare global {
  interface Window {
    __CAT_TOWN__?: {
      getState: () => ReturnType<GameStore["getSnapshot"]>;
      getAnimationState: () => ReturnType<FarmSceneV2["getAnimationDebug"]> | null;
      storageKey: string;
      version: string;
      build: typeof BUILD_INFO;
    };
  }
}

const store = new GameStore();
let game: Phaser.Game | undefined;
const ui = new GameUI(store, gameEvents);
ui.mount(document.querySelector<HTMLDivElement>("#ui-root")!);

window.__CAT_TOWN__ = {
  getState: () => store.getSnapshot(),
  getAnimationState: () => {
    if (!game?.scene.isActive("FarmScene")) return null;
    return (game.scene.getScene("FarmScene") as FarmSceneV2).getAnimationDebug();
  },
  storageKey: store.storageKey,
  version: BUILD_INFO.version,
  build: BUILD_INFO,
};

const buildVersion = document.querySelector<HTMLElement>("#build-version");
const buildId = document.querySelector<HTMLElement>("#build-id");
const buildDate = document.querySelector<HTMLElement>("#build-date");
if (buildVersion) buildVersion.textContent = `v${BUILD_INFO.version}`;
if (buildId) buildId.textContent = `Build ${BUILD_INFO.id}`;
if (buildDate) buildDate.textContent = BUILD_INFO.date;

window.addEventListener("error", (event) => {
  showFatalError(event.error instanceof Error ? event.error : new Error(event.message));
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
  showFatalError(reason);
});

function showFatalError(error: Error): void {
  console.error("[CatTown] Fatal error", error);
  const overlay = document.querySelector<HTMLDivElement>("#error-overlay");
  const message = document.querySelector<HTMLParagraphElement>("#error-message");
  if (overlay && message) {
    message.textContent = error.message || "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ";
    overlay.hidden = false;
  }
}

document.querySelector<HTMLButtonElement>("#reload-button")?.addEventListener("click", () => {
  window.location.reload();
});

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "game-container",
  width: 1487,
  height: 1058,
  backgroundColor: "#9ed9f5",
  transparent: false,
  antialias: true,
  roundPixels: true,
  scene: [BootScene, FarmSceneV2],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 1487,
    height: 1058,
  },
  render: {
    antialias: true,
    pixelArt: false,
    powerPreference: "high-performance",
    preserveDrawingBuffer: true,
  },
  callbacks: {
    preBoot: (game) => {
      game.registry.set("store", store);
      game.registry.set("events", gameEvents);
    },
  },
};

game = new Phaser.Game(config);
